import { render, staticRenderFns } from "./import_spots.vue?vue&type=template&id=c2d75c52&scoped=true&"
import script from "./import_spots.vue?vue&type=script&lang=js&"
export * from "./import_spots.vue?vue&type=script&lang=js&"
import style0 from "./import_spots.vue?vue&type=style&index=0&id=c2d75c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d75c52",
  null
  
)

export default component.exports